"use client";

import { Home } from "lucide-react";
import LocaleLink from "@/components/common/LocaleLink";
import { useLocale } from "@/contexts/LocaleContext";
import type { Locale } from "@/i18n/config";

const copy: Record<
  Locale,
  {
    eyebrow: string;
    title: string;
    description: string;
    primary: string;
  }
> = {
  en: {
    eyebrow: "Page not found",
    title: "404",
    description:
      "The page you are looking for may have been moved, removed, or is temporarily unavailable.",
    primary: "Back to home",
  },
  vi: {
    eyebrow: "Không tìm thấy trang",
    title: "404",
    description:
      "Trang bạn đang tìm có thể đã được di chuyển, bị xóa hoặc tạm thời không khả dụng.",
    primary: "Về trang chủ",
  },
};

export default function NotFound() {
  const { locale } = useLocale();
  const text = copy[locale];

  return (
    <>
      <main className="vivoo-not-found-page bg-white text-black">
        <section className="mx-auto flex min-h-[72vh] max-w-7xl flex-col items-center justify-center px-4 py-12 text-center sm:px-6 sm:py-20 lg:px-10">
          <p className="text-2xl font-semibold tracking-[0.22em] text-blue-600 uppercase">
            {text.eyebrow}
          </p>

          <h1 className="mt-5 text-[96px] leading-none font-semibold tracking-[-0.06em] text-black sm:text-[160px] lg:text-[220px]">
            {text.title}
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-7 text-black/65 sm:text-lg sm:leading-8">
            {text.description}
          </p>

          <LocaleLink
            href="/"
            className="mt-8 inline-flex h-12 items-center justify-center gap-2 rounded-full bg-blue-600 px-6 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(37,99,235,0.25)] transition hover:bg-blue-700"
          >
            <Home className="h-4 w-4" />
            {text.primary}
          </LocaleLink>
        </section>
      </main>

      <style jsx global>{`
        .vivoo-not-found-page + section {
          display: none;
        }
      `}</style>
    </>
  );
}
